import axios from "axios";
import { useEffect, useState } from "react";
import SideFormWrapper from "../Components/SideFormWrapper";
import { TextInput } from "../Components/TextInput";
import "../styles/stocktransfer.css";
export default function StockTransfers() {
  const [transfers, setTransfers] = useState([]);
  const [formState, setFormState] = useState(false);

  const toggleForm = (e, flag) => {
    setFormState(flag);
  };
  function handleSubmit(e) {
    //console.log(data);
    const formData_main = new FormData(e.target);
    const data = Object.fromEntries(formData_main.entries());

    axios
      .post(`${process.env.REACT_APP_LOCAL_API_URL}/admin/create-transfer`, {
        data,
      })
      .then((res) => {
        const { error } = res.data;
        if (!error) {
          toggleForm(false);
        }
      });
  }
  const CreateTransferForm = () => {
    return (
      <form
        method="POST"
        onClick={(e) => {
          e.stopPropagation();
        }}
        onSubmit={(e) => {
          e.preventDefault();

          handleSubmit(e);
        }}
      >
        <TextInput name={"from"} label={"From"} />
        <TextInput name={"to"} label={"to"} />
        <TextInput name={"item"} label={"Item"} />
        <TextInput name={"qty"} label={"Quantity"} />

        <select name="status" defaultValue={"pending"}>
          <option value={"0"}>Choose Status</option>
          <option value={"pending"}>Pending</option>
          <option value={"completed"}>Completed</option>
        </select>

        <section className="btns-section">
          <button>Confirm</button>
          <button
            id="cancel-btn"
            onClick={(e) => {
              toggleForm(e, false);
            }}
          >
            Cancel
          </button>
        </section>
      </form>
    );
  };
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_LOCAL_API_URL}/admin/create-transfer`)
      .then((res) => {
        const { data } = res.data;
        console.log(data);
        setTransfers(data);
      });
  }, [formState]);

  return (
    <>
      {formState && (
        <SideFormWrapper
          children={<CreateTransferForm />}
          toggleForm={toggleForm}
        />
      )}
      <section className="page-title-section">
        <h1>Stock Transfers</h1>
        <button
          className="btn"
          onClick={(e) => {
            toggleForm(e, true);
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-truck"
            viewBox="0 0 16 16"
          >
            <path d="M0 3.5A1.5 1.5 0 0 1 1.5 2h9A1.5 1.5 0 0 1 12 3.5V5h1.02a1.5 1.5 0 0 1 1.17.563l1.481 1.85a1.5 1.5 0 0 1 .329.938V10.5a1.5 1.5 0 0 1-1.5 1.5H14a2 2 0 1 1-4 0H5a2 2 0 1 1-3.998-.085A1.5 1.5 0 0 1 0 10.5zm1.294 7.456A2 2 0 0 1 4.732 11h5.536a2 2 0 0 1 .732-.732V3.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .294.456M12 10a2 2 0 0 1 1.732 1h.768a.5.5 0 0 0 .5-.5V8.35a.5.5 0 0 0-.11-.312l-1.48-1.85A.5.5 0 0 0 13.02 6H12zm-9 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m9 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2" />
          </svg>
          Create Transfer
        </button>
      </section>

      <table className="transfers-table">
        <thead>
          <tr>
            <th>Transfer ID</th>
            <th>From</th>
            <th>To</th>
            <th>Item</th>
            <th>Quantity</th>
            <th>Status</th>
            <th>Date</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {transfers.map((transfer) => (
            <tr key={transfer.id}>
              <td>{transfer.id}</td>
              <td>{transfer.from}</td>
              <td>{transfer.to}</td>
              <td>{transfer.item}</td>
              <td>{transfer.qty}</td>
              <td>
                <span className={`status ${transfer.status.toLowerCase()}`}>
                  {transfer.status}
                </span>
              </td>
              <td>{transfer.created_at.split(".")[0]}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
